import React from 'react';

const JcbIcon = () => (
    <svg
        height="28"
        width="38"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient
                id="a"
                x1="-57.527%"
                x2="232.391%"
                y1="50.124%"
                y2="50.124%"
            >
                <stop
                    offset="0%"
                    stopColor="#007940"
                />
                <stop
                    offset="22.85%"
                    stopColor="#00873F"
                />
                <stop
                    offset="74.33%"
                    stopColor="#40A737"
                />
                <stop
                    offset="100%"
                    stopColor="#5CB531"
                />
            </linearGradient>
            <linearGradient
                id="b"
                x1=".183%"
                x2="100.273%"
                y1="49.96%"
                y2="49.96%"
            >
                <stop
                    offset="0%"
                    stopColor="#007940"
                />
                <stop
                    offset="22.85%"
                    stopColor="#00873F"
                />
                <stop
                    offset="74.33%"
                    stopColor="#40A737"
                />
                <stop
                    offset="100%"
                    stopColor="#5CB531"
                />
            </linearGradient>
            <linearGradient
                id="c"
                x1="-62.802%"
                x2="253.671%"
                y1="49.858%"
                y2="49.858%"
            >
                <stop
                    offset="0%"
                    stopColor="#007940"
                />
                <stop
                    offset="22.85%"
                    stopColor="#00873F"
                />
                <stop
                    offset="74.33%"
                    stopColor="#40A737"
                />
                <stop
                    offset="100%"
                    stopColor="#5CB531"
                />
            </linearGradient>
            <linearGradient
                id="d"
                x1=".176%"
                x2="101.808%"
                y1="50.006%"
                y2="50.006%"
            >
                <stop
                    offset="0%"
                    stopColor="#1F286F"
                />
                <stop
                    offset="47.51%"
                    stopColor="#004E94"
                />
                <stop
                    offset="82.61%"
                    stopColor="#0066B1"
                />
                <stop
                    offset="100%"
                    stopColor="#006FBC"
                />
            </linearGradient>
            <linearGradient
                id="e"
                x1="-.576%"
                x2="98.133%"
                y1="49.914%"
                y2="49.914%"
            >
                <stop
                    offset="0%"
                    stopColor="#6C2C2F"
                />
                <stop
                    offset="17.35%"
                    stopColor="#882730"
                />
                <stop
                    offset="57.31%"
                    stopColor="#BE1833"
                />
                <stop
                    offset="85.85%"
                    stopColor="#DC0436"
                />
                <stop
                    offset="100%"
                    stopColor="#E60039"
                />
            </linearGradient>
        </defs>
        <g
            fill="none"
            fillRule="evenodd"
        >
            <path d="M37.925 0H2.05C1.025 0 0 1.116 0 2.232v22.32C0 26.784 1.025 27.9 3.075 27.9h34.85c2.05 0 3.075-1.116 3.075-3.348V3.348C41 1.116 39.975 0 37.925 0Z"/>
            <path d="M30.907 19.51c0 2.398-1.932 4.35-4.304 4.35H3.186V6.632c0-2.398 1.932-4.35 4.304-4.35h23.417V19.51Z"/>
            <path
                d="M23.282 15.091h1.78c.05 0 .169-.017.22-.017a.8.8 0 0 0 .626-.805.83.83 0 0 0-.627-.805c-.05-.017-.152-.017-.22-.017h-1.779v1.644Z"
                fill="url(#a)"
            />
            <path
                d="M24.857 3.737c-1.693 0-3.082 1.387-3.082 3.117v3.237h4.355c.101 0 .22 0 .305.017.982.051 1.711.565 1.711 1.456 0 .702-.491 1.301-1.406 1.42v.035c1 .069 1.762.634 1.762 1.507 0 .942-.847 1.559-1.966 1.559h-4.779v6.336h4.524c1.695 0 3.084-1.387 3.084-3.117V3.737h-4.508Z"
                fill="url(#b)"
            />
            <path
                d="M25.688 11.769a.726.726 0 0 0-.627-.736c-.034 0-.118-.017-.17-.017h-1.608v1.507h1.61c.05 0 .152 0 .17-.018a.726.726 0 0 0 .626-.736h-.001Z"
                fill="url(#c)"
            />
            <path
                d="M7.812 3.738c-1.695 0-3.084 1.387-3.084 3.117v7.689c.864.428 1.762.702 2.66.702 1.068 0 1.644-.65 1.644-1.541v-3.63h2.643v3.613c0 1.404-.864 2.551-3.795 2.551-1.78 0-3.169-.394-3.169-.394v6.56h4.524c1.695 0 3.084-1.388 3.084-3.117V3.738H7.812Z"
                fill="url(#d)"
            />
            <path
                d="M16.335 3.738c-1.695 0-3.084 1.387-3.084 3.117v4.075c.78-.668 2.135-1.096 4.32-.993 1.17.051 2.424.377 2.424.377v1.318c-.627-.325-1.373-.616-2.338-.685-1.661-.12-2.66.703-2.66 2.141 0 1.456.999 2.278 2.66 2.14.965-.068 1.71-.376 2.338-.684v1.318s-1.237.326-2.423.377c-2.186.103-3.542-.325-4.321-.993v7.193h4.524c1.695 0 3.084-1.388 3.084-3.117V3.738h-4.524Z"
                fill="url(#e)"
            />
        </g>
    </svg>
);

export default JcbIcon;
